module.exports = __webpack_public_path__ + "fasaw6.png?3503df56b2b6b78d9459e0d9adb6fa5b";